import { Component, Vue, Prop } from 'vue-property-decorator';

@Component({
  computed: {
    computedValue: {
      get() {
        return this.value;
      },
      set(newVal) {
        this.$emit('input', newVal);
      },
    },
  },
})
export default class VCustomMenu extends Vue {
  @Prop()
  id: any;
  @Prop()
  dataCy: any;
  @Prop()
  value: any;
  @Prop()
  disabled: any;
  @Prop()
  returnValue: any;
  @Prop()
  closeOnContentClick: any;
  @Prop()
  openOnClick: any;
  @Prop()
  maxHeight: any;
  @Prop()
  minWidth: any;
  @Prop()
  nudgeRight: any;
  @Prop()
  nudgeLeft: any;
  @Prop()
  nudgeTop: any;
  @Prop()
  nudgeBottom: any;
  @Prop()
  offsetX: any;
  @Prop()
  offsetY: any;
  @Prop()
  zIndex: any;
  @Prop()
  positionX: any;
  @Prop()
  positionY: any;
  @Prop()
  attach: any;
  @Prop()
  rounded: any;
  @Prop()
  left: any;
  @Prop({ default: 'mdi-dots-horizontal' })
  icon: any;
  @Prop({ default: 'blue' })
  color: any;
  @Prop()
  contentClass: any;

  public toggleMenu: Boolean = false;

  mounted(): void {
    const el = document.querySelector('#app-identifier');
    if (el) {
      el.addEventListener('scroll', this.handleScroll);
    } else {
    }
  }

  beforeDestroy(): void {
    const el = document.querySelector('#app-identifier');
    if (el) {
      el.removeEventListener('scroll', this.handleScroll);
    }
  }

  public handleScroll() {
    const shopRef = this.$refs[this.id] as Vue & { isMenuActive: boolean };
    shopRef.isMenuActive = false;
    this.toggleMenu = false;
  }
}
